var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18941 1.1895C1.7751 0.6038 2.72471 0.6038 3.31041 1.1895L8.99991 6.879L14.6894 1.1895C15.2751 0.603801 16.2247 0.6038 16.8104 1.1895C17.3961 1.7752 17.3961 2.7248 16.8104 3.3105L11.1209 9L16.8104 14.6895C17.3961 15.2752 17.3961 16.2248 16.8104 16.8105C16.2247 17.3962 15.2751 17.3962 14.6894 16.8105L8.99991 11.121L3.31041 16.8105C2.72471 17.3962 1.7751 17.3962 1.18941 16.8105C0.603709 16.2248 0.603708 15.2752 1.18941 14.6895L6.87891 9L1.18941 3.3105C0.60371 2.7248 0.603708 1.7752 1.18941 1.1895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/whiteCross.ff326f7c8acc6b87ebb6194afcdf80b7.svg";
export { ForwardRef as ReactComponent };